module.exports = __webpack_public_path__ + "static/media/citra-coffee-stout.96ef87ed.webp";